import styled, { css } from "styled-components";

import { ConsolePageButtonContainer } from "@Console/components/molecules/ConsolePageForm/atoms/ConsolePageButton/styles";

interface SatisfactionSurveyModalContainer {
  show: boolean;
}
export const SatisfactionSurveyModalContainer = styled.div<SatisfactionSurveyModalContainer>`
  background: rgb(0 0 0 / 74%);
  backdrop-filter: blur(4px);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s all;
  opacity: ${({ show }) => (show ? "1" : "0")};
  pointer-events: ${({ show }) => (show ? "all" : "none")};
  z-index: 9999999;

  * {
    transition: 0.3s all;
  }
`;

const surveyButtonHoverEffect = css`
  cursor: pointer;

  background-color: #0073e51f;

  border: 1px solid #0073e5;

  img {
    opacity: 1;
  }
`;

export const SatisfactionSurveyModalContent = styled.div`
  background-color: ${({ theme }) =>
    theme.groups.satisfactionSurveyModalBackgroundColor};

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  border-radius: 4px;
  padding: 1.5rem;
  border: 1px solid
    ${({ theme }) => theme.colors.searchPage.inputBackgroundColorHover};

  p {
    all: unset;
    font: 600 0.875rem/1.488rem "Inter";
    color: ${({ theme }) => theme.groups.primaryText} !important;
  }

  ${ConsolePageButtonContainer} {
    @media (max-width: 600px) {
      width: min-content !important;
    }

    @media (max-width: 475px) {
      width: 87% !important;
    }
  }
`;

export const SatisfactionSurveyButtonContainer = styled.div`
  margin-bottom: 0.5rem;

  span {
    all: unset;
    font: 400 0.75rem/1.275rem "Inter";
    color: ${({ theme }) => theme.groups.secondaryText} !important;
  }

  .stars {
    direction: rtl;

    .star:is(:hover:not(:disabled), :active, :focus, .selected),
    .star:is(:hover:not(:disabled), :active, :focus, .selected) ~ .star {
      ${surveyButtonHoverEffect};
    }
  }

  .emojis {
    .emoji:is(:hover:not(:disabled), :active, :focus, .selected) {
      ${surveyButtonHoverEffect};
    }
  }

  .numeric {
    font: 700 1rem/1.7rem "Inter";
    color: ${({ theme }) => theme.groups.primaryText} !important;

    .number:is(:hover:not(:disabled), :active, :focus, .selected) {
      ${surveyButtonHoverEffect};
    }
  }

  @media (max-width: 475px) {
    width: auto;
  }
`;

export const SatisfactionSurveyButtonContent = styled.div`
  * {
    transition: all 0.2s;
  }

  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  &.emojis,
  &.numeric {
    flex-direction: column-reverse;
  }

  @media (min-width: 476px) {
    display: grid;
    grid-template-columns: repeat(5, 4.5rem);
  }
`;

export const SatisfactionSurveyScaleExplanation = styled.div`
  display: flex;
  justify-content: space-between;

  margin-top: 8px;

  span {
    all: unset;
    font: 400 0.75rem/1.275rem "Inter";
    color: ${({ theme }) => theme.groups.secondaryText} !important;
  }
`;

export const SatisfactionSurveyConcludeFeedback = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  gap: 0.5rem;

  max-width: 100%;

  p {
    all: unset;
    font: 400 0.813rem/1.375rem "Inter";
    color: ${({ theme }) => theme.groups.primaryText} !important;
  }

  span {
    font-size: 1rem;
  }

  .loader {
    height: 1rem;
    width: 1rem;
  }

  @media (min-width: 476px) {
    flex-direction: row;
  }
`;

export const SatisfactionSurveyModalButton = styled.button`
  align-items: center;
  display: flex;
  justify-content: center;

  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.groups.groupFeedCommentCorderColor};
  color: ${({ theme }) => theme.groups.secondaryText} !important;

  border-radius: 4px;

  font-size: 1.3rem;

  position: relative;

  min-height: 2.5rem;

  img {
    opacity: 0;

    position: absolute;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    pointer-events: none;
  }
`;
